import { render } from "./FrameHole.vue?vue&type=template&id=3e93851a&scoped=true"
import script from "./FrameHole.vue?vue&type=script&lang=js"
export * from "./FrameHole.vue?vue&type=script&lang=js"

import "./FrameHole.vue?vue&type=style&index=0&id=3e93851a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e93851a"]])

export default __exports__